import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Column } from 'primereact/column'
import { Panel } from 'primereact/panel'
import { FiDownload } from 'react-icons/fi'
import {
  Btn,
  CustomCalendar,
  CustomDataTable,
  CustomDataTableHeader,
  CustomDropdown,
  PageHeader,
  TextBtn,
} from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { tableCellCentered } from '../../../../assets/js/styles'
import { parseToMysqlFormat } from '../../../../services/util/date.service'
import useComparativoEntradaAvulsoPicking, {
  LOAD_MESSAGE,
} from './ComparativoEntradaAvulsoPickingHook'

function formatNumber(value) {
  const numberValue = Number(value || 0)
  if (Number.isInteger(numberValue)) return numberValue
  return Number(numberValue.toFixed(4))
}

function diferencaColor(diferenca) {
  const value = Number(diferenca || 0)
  if (value < 0) return 'red'
  if (value > 0) return 'green'
  return 'black'
}

function posicoesEstoqueBody(row) {
  const posicoesEstoque = row.posicoes_estoque || ''
  if (!posicoesEstoque) return ''

  return (
    <span>
      {posicoesEstoque.split(';').map((grupo, index, grupos) => {
        const [estoque, ...posicoes] = grupo.split(':')
        const separator = index < grupos.length - 1 ? '; ' : ''

        if (!posicoes.length) {
          return (
            <React.Fragment key={`${grupo}-${index}`}>
              {grupo}
              {separator}
            </React.Fragment>
          )
        }

        return (
          <React.Fragment key={`${estoque}-${index}`}>
            <strong>{estoque.trim()}</strong>: {posicoes.join(':').trim()}
            {separator}
          </React.Fragment>
        )
      })}
    </span>
  )
}

function ComparativoEntradaAvulsoPicking({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useComparativoEntradaAvulsoPicking()

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.FETCH_INITIAL_INFO:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getCompaniesAssociatedToUser()
        break

      case LOAD_MESSAGE.GET_PICKINGS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getPickingsPorEmpresa(
          state.companySelected.id,
          selectedTp,
          parseToMysqlFormat(state.pInicial),
          parseToMysqlFormat(state.pFinal),
        )
        break

      case LOAD_MESSAGE.GET_REPORT:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getRelatorio(selectedTp, state.selectedPicking.value)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  useEffect(() => {
    localDispatch.onInit()
  }, [selectedTp])

  const temPickings = state.pickingOptions && state.pickingOptions.length > 0
  const temRelatorio = state.rows && state.rows.length > 0

  return (
    <>
      <PageHeader>8.24 - Comparativo Entrada Avulso - Picking X Picking</PageHeader>
      <div style={{ marginTop: 16, minHeight: '80vh' }}>
        <Panel header={<TextBtn onClick={history.goBack}>Voltar</TextBtn>}>
          <div className="p-grid p-justify-center">
            <div className="p-grid p-col-12">
              <div className="p-col-12 p-lg-3">
                <CustomDropdown
                  showLabel={true}
                  label="Empresa"
                  optionLabel="name"
                  marginTop={10}
                  options={state.companies}
                  value={state.companySelected}
                  onChange={localDispatch.onCompanyChange}
                  filter
                />
              </div>

              <div className="p-col-12 p-lg-3">
                <CustomCalendar
                  label="Período Inicial"
                  value={state.pInicial}
                  onChange={localDispatch.onPeriodoInicialChange}
                />
              </div>

              <div className="p-col-12 p-lg-3">
                <CustomCalendar
                  label="Período Final"
                  value={state.pFinal}
                  onChange={localDispatch.onPeriodoFinalChange}
                />
              </div>

              <div className="p-col-fixed">
                <div style={{ marginLeft: 10, paddingTop: 27 }}>
                  <Btn
                    onClick={() =>
                      localDispatch.onBtnPesquisar(
                        state.companySelected,
                        selectedTp,
                        state.pInicial,
                        state.pFinal,
                      )
                    }
                  >
                    Pesquisar
                  </Btn>
                </div>
              </div>
            </div>
          </div>

          {temPickings && (
            <div className="p-grid p-col-12" style={{ marginTop: 16 }}>
              <div className="p-col-12 p-lg-4">
                <CustomDropdown
                  label="Pickings"
                  options={state.pickingOptions}
                  value={state.selectedPicking}
                  onChange={localDispatch.onPickingChange}
                  optionLabel="label"
                  filter
                />
              </div>

              <div className="p-col-12 p-lg-2" style={{ paddingTop: 27 }}>
                <Btn
                  onClick={() => localDispatch.onGerarRelatorio(selectedTp, state.selectedPicking)}
                >
                  Gerar Relatório
                </Btn>
              </div>
            </div>
          )}

          {temRelatorio && (
            <>
              <div style={{ marginTop: 16, marginBottom: 16 }}>
                <Btn
                  disabled={!state.filteredRows.length}
                  onClick={() => localDispatch.exportExcel(state.filteredRows)}
                >
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <FiDownload size={18} />
                    <span style={{ marginLeft: 5 }}>Exportar</span>
                  </div>
                </Btn>
              </div>

              <CustomDataTable
                value={state.filteredRows}
                paginator={true}
                rows={15}
                emptyMessage="Nenhum dado encontrado"
                header={<CustomDataTableHeader onChange={localDispatch.onGlobalFilterChange} />}
                globalFilter={state.globalFilter}
                responsive={true}
                className="auto-layout"
              >
                <Column
                  field="product_code"
                  header="Código"
                  style={{
                    ...tableCellCentered(200),
                    minWidth: 200,
                    whiteSpace: 'nowrap',
                  }}
                />
                <Column field="produto" header="Produto" style={{ minWidth: 360 }} />
                <Column
                  field="qtd_picking"
                  header="Qtd Picking"
                  style={tableCellCentered(95)}
                  body={row => formatNumber(row.qtd_picking)}
                />
                <Column
                  field="qtd_internada"
                  header="Qtd Internada"
                  style={tableCellCentered(105)}
                  body={row => formatNumber(row.qtd_internada)}
                />
                <Column
                  field="diferenca"
                  header="Diferença"
                  style={tableCellCentered(90)}
                  body={row => (
                    <span style={{ color: diferencaColor(row.diferenca) }}>
                      {formatNumber(row.diferenca)}
                    </span>
                  )}
                />
                <Column
                  field="posicoes_estoque"
                  header="Posições de Estoque"
                  body={posicoesEstoqueBody}
                  style={{ minWidth: 520, whiteSpace: 'normal', lineHeight: 1.4 }}
                />
              </CustomDataTable>
            </>
          )}
        </Panel>
      </div>
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(ComparativoEntradaAvulsoPicking))
